export const RequestedDeliveryDateRange = {
  Start: 3,
  End: 7
};
